/* unplugin-vue-components disabled */import script from "./kfDia.vue?vue&type=script&setup=true&lang=js"
export * from "./kfDia.vue?vue&type=script&setup=true&lang=js"

import "./kfDia.vue?vue&type=style&index=0&id=27186eda&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27186eda"]])

export default __exports__